// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 99%;
  }
  
  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }
  
  tr:nth-child(even) {
    background-color: #dddddd;
  }

  /* table, th, td {
    border:1px solid black;
  } */

  /* tr:nth-child(even) {
    background-color: rgba(226, 24, 24, 0.4);
  }
  
  th:nth-child(even),td:nth-child(even) {
    background-color: rgba(207, 241, 14, 0.4);
  } */












  



  /* Dropdown Button */
.dropbtn {
  background-color: #07c5ff;
  color: #5d1b8d;
  padding: 16px;
  font-size: 16px;
  border: none;
  margin-right: 10px;
}
.dropbtn:hover {
  background-color: #16e7e7;
}

/* The container <div> - needed to position the dropdown content */
/* .dropdown {
  position: relative;
  display: inline-block;
} */

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 186px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

/* Show the dropdown menu on hover */
/* .dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content.show {
  display: block;
}
 */


/* 
.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
}


.dropdown-content {
  display: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}
 */

 .dropdown-content {
  display: block;
}

/* Optional: Adjust the positioning if needed */
.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
}

.table-scroll {
  max-height: 600px; /* Adjust this height based on your requirement */
  overflow-y: auto;
  display: inline-block;
  width: 100%;
}

.table-scroll thead th {
  position: sticky;
  top: 0;
  background-color: #fff; /* Add a background color to the header */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */
}



`, "",{"version":3,"sources":["webpack://./src/components/priority/priority.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;KAEG;;EAEH;;;;;;KAMG;;;;;;;;;;;;;;;;;EAiBH,oBAAoB;AACtB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;;;GAGG;;AAEH,yCAAyC;AACzC;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA,oCAAoC;AACpC;;;;;;;EAOE;;;AAGF;;;;;;;;;;;;;;;EAeE;;CAED;EACC,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,iBAAiB,EAAE,iDAAiD;EACpE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB,EAAE,yCAAyC;EACjE,6CAA6C,EAAE,kCAAkC;AACnF","sourcesContent":["table {\r\n    font-family: arial, sans-serif;\r\n    border-collapse: collapse;\r\n    width: 99%;\r\n  }\r\n  \r\n  td, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    padding: 8px;\r\n  }\r\n  \r\n  tr:nth-child(even) {\r\n    background-color: #dddddd;\r\n  }\r\n\r\n  /* table, th, td {\r\n    border:1px solid black;\r\n  } */\r\n\r\n  /* tr:nth-child(even) {\r\n    background-color: rgba(226, 24, 24, 0.4);\r\n  }\r\n  \r\n  th:nth-child(even),td:nth-child(even) {\r\n    background-color: rgba(207, 241, 14, 0.4);\r\n  } */\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n  \r\n\r\n\r\n\r\n  /* Dropdown Button */\r\n.dropbtn {\r\n  background-color: #07c5ff;\r\n  color: #5d1b8d;\r\n  padding: 16px;\r\n  font-size: 16px;\r\n  border: none;\r\n  margin-right: 10px;\r\n}\r\n.dropbtn:hover {\r\n  background-color: #16e7e7;\r\n}\r\n\r\n/* The container <div> - needed to position the dropdown content */\r\n/* .dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n} */\r\n\r\n/* Dropdown Content (Hidden by Default) */\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f1f1f1;\r\n  min-width: 186px;\r\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\r\n  z-index: 1;\r\n}\r\n\r\n/* Show the dropdown menu on hover */\r\n/* .dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n.dropdown-content.show {\r\n  display: block;\r\n}\r\n */\r\n\r\n\r\n/* \r\n.dropdown-content {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n}\r\n\r\n\r\n.dropdown-content {\r\n  display: none;\r\n}\r\n\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n */\r\n\r\n .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n/* Optional: Adjust the positioning if needed */\r\n.dropdown-content {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n}\r\n\r\n.table-scroll {\r\n  max-height: 600px; /* Adjust this height based on your requirement */\r\n  overflow-y: auto;\r\n  display: inline-block;\r\n  width: 100%;\r\n}\r\n\r\n.table-scroll thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color: #fff; /* Add a background color to the header */\r\n  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
